export default __webpack_public_path__ + "static/media/collapse-right.ee796ec5.svg";